import { ArrowBack, ArrowCircleRight, AttachMoney, People } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Chip, Grid, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import userStore from 'store/userStore'
import MiniStatisticsCard from 'examples/Cards/StatisticsCards/MiniStatisticsCard'
import { MaterialReactTable } from 'material-react-table'
import { postDataWithResponse } from 'global/postFunc'
import { getDataWithResponse } from 'global/getFunc'

const RincianBelanja = () => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [totalRincian, setTotalRincian] = useState(0)

    const navigate = useNavigate()
    const location = useLocation()
    const data = location.state

    const [kegiatan, setKegiatan] = useState({})
    const [program, setProgram] = useState({})
    const [listRincian, setListRincian] = useState([])

    const date = new Date();
    const bulan = date.getMonth()

    useEffect(() => {
        getTrKegiatan()
        getTrProgram()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(program);
    }, [program])

    const getTrKegiatan = () => {
        addReq()
        getDataWithResponse(
            // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
            `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${data.kegiatan}`,
            decryptedUser,
            (res) => {
                setKegiatan(res)
                console.log(res);
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        )
    }


    const getTrProgram = () => {
        addReq()
        getDataWithResponse(
            // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
            `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${data.program}`,
            decryptedUser,
            (res) => {
                setProgram(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        )
    }

    const reqRincianBelanja = () => {
        addReq()
        postDataWithResponse(
            '/admin-opd/komponen-belanja',
            {
                kd_subkegiatan: data.sub_kegiatan,
                kd_pd: data.kd_pd,
                ta: data.ta
            },
            decryptedUser,
            (res) => {
                setListRincian(res)
                const sum = res.reduce((accumulator, object) => {
                    return accumulator + parseInt(object.anggaran);
                }, 0);
                setTotalRincian(sum)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqRincianBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [loading, setLoading] = useState(false)

    const columns = [
        {
            accessorKey: 'nama_komponen',
            header: 'Uraian',
            size: 500,
            Cell: ({ cell }) => (
                <Box>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                        color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                    >
                        {cell.row.original.status === 'kel_paket' ? '[#] ' : ''}{cell.getValue()}
                    </ArgonTypography>
                    {
                        cell.row.original.status === 'komponen' &&
                        (
                            <>
                                <ArgonTypography
                                    fontSize="small"
                                    variant="inherit"
                                    color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                                >
                                    Spesifikasi : {cell.row.original.spesifikasi}
                                </ArgonTypography>
                                <Chip
                                    size='small'
                                    variant='outlined'
                                    label={
                                        cell.row.original.laporan_terakhir.bulan === null ? "Realisasi belum dilaporkan" : "Laporan Terakhir Bulan " + cell.row.original.laporan_terakhir.bulan
                                    } color={
                                        (parseInt(cell.row.original.laporan_terakhir.bulan) < bulan || cell.row.original.laporan_terakhir.bulan === null) ? 'error' : 'success'
                                    }
                                />
                            </>
                        )
                    }
                </Box>
            )
        },
        {
            accessorKey: 'koefisien',
            header: 'Koefisien',
            size: 200,
            Cell: ({ cell }) => (
                cell.row.original.status === 'komponen' &&
                (
                    <ArgonTypography
                        // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                        variant="inherit"
                        fontSize="small"
                        color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                    >
                        {cell.getValue() + ' ' + cell.row.original.satuan}
                    </ArgonTypography>
                )
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            size: 200,
            Cell: ({ cell }) => (
                cell.row.original.status === 'komponen' ?
                    (
                        <ArgonTypography
                            // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                            variant="inherit"
                            fontSize="small"
                            color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                        >
                            {
                                parseInt(cell.getValue()) === 0 ? ' ' : parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                        </ArgonTypography>
                    )
                    :
                    ('')
            )
        },
        {
            accessorKey: 'status_pelaksanaan',
            header: 'Progres',
            size: 200,
            Cell: ({ cell }) => (
                cell.row.original.status === 'komponen' ?
                    (
                        <ArgonTypography
                            // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                            variant="inherit"
                            fontSize="small"
                            color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                        >
                            {
                                cell.getValue() || 'Belum Terlaksana'
                            }
                        </ArgonTypography>
                    )
                    :
                    ('')
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack fontSize='small' /></IconButton>
                        }
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {decodedUser.kd_pd} {decodedUser.nm_pd}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Program</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {program.kode} {program.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={2} >
                                    <TableCell sx={{ fontSize: 'small' }}>Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {kegiatan.kode} {kegiatan.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={3} >
                                    <TableCell sx={{ fontSize: 'small' }}>Sub Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kode} {data.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={4} >
                                    <TableCell sx={{ fontSize: 'small' }}>Kinerja</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kinerja}</TableCell>
                                </TableRow>
                                <TableRow key={5} >
                                    <TableCell sx={{ fontSize: 'small' }}>Indikator</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.indikator}</TableCell>
                                </TableRow>
                                <TableRow key={6} >
                                    <TableCell sx={{ fontSize: 'small' }}>Satuan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.satuan}</TableCell>
                                </TableRow>
                                <TableRow key={7} >
                                    <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        : {
                                            data.anggaran?.toLocaleString?.('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            bgColor='white'
                            title={{
                                text: "Anggaran Sub Kegiatan"
                            }}
                            count={
                                data.anggaran?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "info", component: <AttachMoney /> }}
                        // percentage={{ color: "success", count: "+55%", text: "since yesterday" }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            title={{
                                text: "Total Rincian"
                            }}
                            count={
                                totalRincian?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "error", component: <People /> }}
                            percentage={{ color: "error", text: ((totalRincian / data?.anggaran) * 100).toFixed(2) + '%' }}
                        />
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mb={1}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Rincian Belanja</ArgonTypography>
                        }
                    />
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={listRincian}
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={false}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='first'
                            renderRowActions={({ row, table }) => (
                                row.original.status === 'komponen' &&
                                (
                                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                                        <IconButton
                                            color="info"
                                            component={Link}
                                            to='/a-pemb/laporan/komponen'
                                            state={row.original.id}
                                        >
                                            <ArrowCircleRight fontSize='small' />
                                        </IconButton>
                                    </Box>
                                )
                            )}
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Aksi', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'center'
                                },
                            }}
                        />
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default RincianBelanja